export const MEANDER_APP_STORE_URL =
  'https://apps.apple.com/us/app/meanderev/id6742797523';

export const MEANDER_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.meanderev.charge';
